






import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'alert'
})
export default class Alert extends Vue {

}
